module.exports = __webpack_public_path__ + "img/未标题-3-06.04ff39de.png";